import { render, staticRenderFns } from "./metric-chart-view.vue?vue&type=template&id=3b3e3630"
import script from "./metric-chart-view.vue?vue&type=script&lang=js"
export * from "./metric-chart-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports